import React from 'react'
import {IconProps} from '../../types/IconProps'

const RightArrowIcon = ({height, width, color}: IconProps) => {
  return (
    <svg
      width={width || '14'}
      height={height || '10'}
      viewBox='0 0 14 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        id='Icon'
        d='M8.08624 8.48136C7.77944 8.77524 7.77944 9.25171 8.08624 9.54558C8.39303 9.83946 8.89044 9.83946 9.19724 9.54558L13.3871 5.53215C13.5405 5.38521 13.6172 5.19262 13.6172 5.00003C13.6172 4.898 13.596 4.80071 13.5576 4.71198C13.5192 4.62323 13.4624 4.54007 13.3871 4.46792L9.19724 0.454484C8.89044 0.160607 8.39303 0.160607 8.08624 0.454484C7.77944 0.748362 7.77944 1.22483 8.08624 1.51871L10.935 4.24751L0.785763 4.24752C0.35189 4.24752 0.000165486 4.58443 0.000165523 5.00004C0.000165559 5.41564 0.35189 5.75255 0.785763 5.75255L10.935 5.75255L8.08624 8.48136Z'
        fill={color || '#735BF2'}
      />
    </svg>
  )
}

export default RightArrowIcon
